/* eslint-disable prefer-destructuring */
export var API_URL = process.env.API_URL;
export var CP_URL = process.env.CP_URL;
export var NBM_URL = process.env.NBM_URL;
export var SENTRY_DSN = process.env.SENTRY_DSN;
export var ENV = process.env.ENV;
export var SENTRY_ENABLED = process.env.SENTRY_ENABLED === 'true';
export var IS_DEV_ENV = ENV === 'development';
export var IS_STAGING_ENV = ENV === 'staging';
export var IS_PROD_ENV = ENV === 'production';
